"use strict";
/*
 * Created on 10. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Price code settings.
 * @author Radek Beran
 */


var PriceCodeSettings =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PriceCodeSettings, _DomainObject_1$Domai);

  /**
   * Constructs price code settings.
   * @param priceCode title of {@link PriceCode price list code}
   * @param priceCodeId code of price
   * @param priceCodeRule rule for assigning this price code to a product (if there are more possible price codes to choose from)
   * @param rulePriority priority for checking the applicability of rule - the smaller the number,
   * the former checking of this rule should be done
   */
  function PriceCodeSettings(priceCode, priceCodeId, priceCodeRule, rulePriority) {
    var _this;

    _classCallCheck(this, PriceCodeSettings);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceCodeSettings).call(this));
    _this.priceCode = priceCode;
    _this.priceCodeId = priceCodeId;
    _this.priceCodeRule = priceCodeRule;
    _this.rulePriority = rulePriority;
    return _this;
  }

  return PriceCodeSettings;
}(DomainObject_1.DomainObject);

exports.PriceCodeSettings = PriceCodeSettings;